export default __webpack_public_path__ + "fc4835afd923ecd09ad8a6c1a458a5bc.svg";